import { useState } from "react";
import { FileUploader } from "./components/FileUploader";
import { IllustrationList } from "./components/IllustrationList";
import { Sidebar } from "./components/Sidebar";
import { TagManager } from "./components/TagManager";
import { CloudflareAuthWrapper as AuthWrapper } from "./components/CloudflareAuthWrapper";
import { AboutManager } from "./components/AboutManager";
import { LayoutSections } from "./components/LayoutSections";
import { ImagePlacementManager } from "./components/ImagePlacementManager";
import { WorksManagement } from "./components/WorksManagement";
import { WorksPlacementManager } from "./components/WorksPlacementManager";

const MENU_ITEMS = [
  { id: "upload", label: "アップロード" },
  { id: "illustrations", label: "イラスト一覧" },
  { id: "tags", label: "タグ管理" },
  { id: "about", label: "aboutセクション" },
  { id: "sections", label: "レイアウト登録" },
  { id: "placements", label: "画像配置" },
  { id: "works", label: "作品カテゴリー管理" },
  { id: "worksPlacement", label: "作品配置" },
];

// Cloudflare Worker API のベースURL
const WORKER_API_URL = "https://image-processor.el-calafate.workers.dev";

export const Admin = () => {
  const [activeMenu, setActiveMenu] = useState("upload");
  const [isUploading, setIsUploading] = useState(false);

  const handleUpload = async (
    file: File,
    category: string,
    title: string,
    tagIds: number[]
  ) => {
    try {
      setIsUploading(true);
      const fileName = `${Date.now()}_${file.name}`;
      const filePath = `${category}/${fileName}`;

      // 1. Worker API 経由で R2 にファイルをアップロード
      console.log("📤 R2 へアップロード中...");
      const uploadResponse = await fetch(`${WORKER_API_URL}/api/upload?filename=${encodeURIComponent(fileName)}&category=${category}`, {
        method: "POST",
        headers: {
          "Content-Type": file.type,
        },
        body: file,
      });

      if (!uploadResponse.ok) {
        throw new Error(`アップロードに失敗しました: ${await uploadResponse.text()}`);
      }

      // 2. D1 データベースにレコードを作成
      console.log("📝 D1 にメタデータを登録中...");
      const dbResponse = await fetch(`${WORKER_API_URL}/api/illustrations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title,
          file_name: fileName,
          storage_path: filePath,
          category,
          tag_ids: tagIds,
        }),
      });

      if (!dbResponse.ok) {
        throw new Error(`データベースの登録に失敗しました: ${await dbResponse.text()}`);
      }

      console.log("✨ 全ての処理が完了しました:", filePath);

    } catch (error) {
      console.error("Upload error:", error);
      throw error;
    } finally {
      setIsUploading(false);
    }
  };

  const renderContent = () => {
    switch (activeMenu) {
      case "upload":
        return (
          <FileUploader onUpload={handleUpload} isUploading={isUploading} />
        );
      case "illustrations":
        return <IllustrationList />;
      case "tags":
        return <TagManager />;
      case "about":
        return <AboutManager />;
      case "sections":
        return <LayoutSections />;
      case "placements":
        return <ImagePlacementManager />;
      case "works":
        return <WorksManagement />;
      case "worksPlacement":
        return <WorksPlacementManager />;
      default:
        return null;
    }
  };

  return (
    <AuthWrapper>
      <div className="flex">
        <Sidebar
          items={MENU_ITEMS}
          activeItem={activeMenu}
          onItemClick={setActiveMenu}
        />
        <main className="flex-1 p-8 bg-gray-100 min-h-screen">
          {renderContent()}
        </main>
      </div>
    </AuthWrapper>
  );
};
